export default __webpack_public_path__ + "static/media/socialMediaManager.07c9b73c.jpg";